/**
 * The ConfirmParam is the data that needs to be passed along in order for a Confirm to be usable by the consumer.
 * Often what you'll actually be passing around is the entity itself, like a CustomerQuote, or Order.Markets entry.
 * Both fields are required; downstream components receive undefined when either field is missing.
 */
export interface ConfirmParam {
  ConfirmType: ConfirmTypeEnum;
  Confirm: ConfirmStructs;
}

export const ConfirmTypeEnum = {
  RepoConfirm: 'RepoConfirm',
} as const;
export type ConfirmTypeEnum = (typeof ConfirmTypeEnum)[keyof typeof ConfirmTypeEnum];

export interface RepoConfirm {
  Rate?: string;
  CashCurrency?: string;
  CollateralAsset?: string;
  StartTime?: string;
  EndTime?: string;
  HaircutRatio?: string;
  CleanPrice?: string;
  AccruedInterest?: string;
  CollateralAssetValue?: string;
  CollateralAssetHaircutAmount?: string;
  DirtyPrice?: string;
  CumCashQty?: string;
  CumCollateralQty?: string;
  StartCash?: string;
  EndCash?: string;
  RepoInterest?: string;
  Direction?: 'Repo' | 'ReverseRepo';
}

/** Currently just contains RepoConfirm, here we'll add in the rest of the confirm structs that we support to do conditional typing... */
export type ConfirmStructs = RepoConfirm;
